<div class="multilingual-modal">
  <h2 md-dialog-title>Multilingual edition</h2>
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <md2-tabs *ngIf="!loading">
      <md2-tab label="Pictures">
        <table>
          <thead>
            <tr>
              <th>Language</th>
              <th>Original</th>
              <th>{{ selectedPictureSet.format }}</th>
              <th>Duplicate</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{ selectedPictureSet.language }}
              </td>
              <td>
                <img [src]="selectedPictureSet.originalPicture" height="50" />
              </td>
              <td>
                <img [src]="selectedPictureSet.originalPicture" height="50" />
              </td>
              <td *ngIf="!checkBox">
                <md-icon
                  mdTooltip="Duplicate for all"
                  class="cursor-pointer"
                  (click)="copyPicture(1)"
                >
                  content_copy
                </md-icon>

                <md-icon
                  mdTooltip="Duplicate to empty"
                  class="cursor-pointer"
                  (click)="copyPicture(2)"
                >
                  copy_all
                </md-icon>

                <md-icon
                  mdTooltip="Copy"
                  class="cursor-pointer"
                  (click)="copyPicture(3)"
                >
                  file_copy
                </md-icon>
              </td>
              <td *ngIf="checkBox">
                <md-icon
                  class="cursor-pointer apply"
                  (click)="applyDuplicatePicture()"
                  mdTooltip="Apply"
                  >check_circle
                </md-icon>
                <md-icon
                  class="cursor-pointer cancel"
                  (click)="cancelDuplicatePicture()"
                  mdTooltip="Cancel"
                  >cancel
                </md-icon>
              </td>
            </tr>
            <tr *ngFor="let picture of additionalPicture">
              <td>{{ picture.languageName }}</td>
              <td>
                <img
                  *ngIf="picture.originalPictureURL != ''"
                  [src]="picture.originalPictureURL"
                  height="50"
                />
                <img
                  *ngIf="picture.originalPictureURL == ''"
                  [src]="picture.originalPictureURL"
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="picture.originalPictureURL != ''"
                  [src]="picture.originalPictureURL"
                  height="50"
                />
                <img
                  *ngIf="picture.originalPictureURL == ''"
                  [src]="picture.cropPictureURL"
                  height="50"
                />
              </td>
              <td *ngIf="!checkBox && !picture.duplicate">
                <md-icon
                  mdTooltip="Duplicate here"
                  class="cursor-pointer"
                  (click)="duplicateEmptyPicture(picture)"
                >
                  copy_all
                </md-icon>
              </td>
              <td *ngIf="checkBox && !picture.duplicate">
                <md-checkbox
                  [(ngModel)]="picture.checked"
                  (change)="checkDuplicatePicture(picture, $event)"
                ></md-checkbox>
              </td>
              <td *ngIf="!checkBox && picture.duplicate">
                <md-icon
                  class="cursor-pointer apply"
                  (click)="applyDuplicatePicture()"
                  mdTooltip="Apply"
                  >check_circle
                </md-icon>
                <md-icon
                  class="cursor-pointer cancel"
                  (click)="cancelDuplicatePicture()"
                  mdTooltip="Cancel"
                  >cancel
                </md-icon>
              </td>
            </tr>
          </tbody>
        </table>
      </md2-tab>
    </md2-tabs>
  </md-dialog-content>
  <md-dialog-actions>
    <div class="actions">
      <div style="justify-content: space-around">
        <button md-raised-button (click)="close()">
          <md-icon>cancel</md-icon>
          Cancel
        </button>
      </div>
      <div>
        <button
          md-raised-button
          color="accent"
          [disabled]="!pictureSetUpdated"
          (click)="save()"
        >
          <md-icon>save</md-icon>
          Save
        </button>
      </div>
    </div>
  </md-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/event-max-multilingual-modal/event-max-multilingual-modal.component.html